import React from 'react';
import { ShieldCheck, X } from 'lucide-react';

// Fixed banner shown while a Platform Admin is inside a tenant via
// "Enter Tenant" impersonation (sessionStorage.impersonation set by
// PlatformPortal). Exit clears the impersonation session and returns
// to /platform.
export const ImpersonationBanner = () => {
  let info = null;
  try {
    info = JSON.parse(sessionStorage.getItem('impersonation') || 'null');
  } catch {
    info = null;
  }
  if (!info) return null;

  const exit = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('impersonation');
    window.location.href = '/platform';
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 text-xs font-medium px-4 py-1.5 flex items-center justify-center gap-3 shadow"
      data-testid="impersonation-banner"
    >
      <ShieldCheck className="h-3.5 w-3.5" />
      <span>
        Viewing <strong>{info.tenant_name}</strong> as Platform Admin ({info.platform_admin}) — all actions are audit-logged
      </span>
      <button
        type="button"
        onClick={exit}
        className="inline-flex items-center gap-1 rounded bg-amber-950/10 hover:bg-amber-950/20 px-2 py-0.5 transition-colors"
        data-testid="impersonation-exit-btn"
      >
        <X className="h-3 w-3" /> Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
